export default "__VITE_ASSET__B01H_byi__"